module.exports = __webpack_public_path__ + "static/media/development.97311749.png";